import TransactionsList from './transactionsList';

// This component is used to display a list of transactions for the user's home page.
// It is used in MyMaterialHomePage.js
export default function MyTransactionsComponent(props) {
  return (
    <div className="myHomePage-content">
      <div>
        <TransactionsList
          matType={props.matType}
          // level on transactions page is used for localStorage only
          // this would retain different localStorage <key, value> for homepage and transactions page
          level={'myHomePage-' + props.level}
          myHomePage={true}
          // user filter on transactions to include all transaction that user is associated with
          filter={'user'}
        />
      </div>
    </div>
  );
}
